const img = require('./porchSideA_active.svg'); export default img;